export interface JwtPayload {
  role?: string;
  email?: string;
  exp?: number;
  user?: { role?: string; email?: string };
  [key: string]: any;
}

/** Decode a JWT payload without verifying the signature (verification happens server-side). */
export function decodeJwt(token: string): JwtPayload | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(b64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getRole(payload: JwtPayload | null): string | undefined {
  return payload?.role ?? payload?.user?.role;
}

export function getEmail(payload: JwtPayload | null): string | undefined {
  return payload?.email ?? payload?.user?.email;
}

export function isExpired(payload: JwtPayload | null): boolean {
  return !!payload?.exp && payload.exp * 1000 < Date.now();
}
